import { useCallback, useEffect, useRef, useState } from "react";
import api from "../api";
import { MOCK_INVOICES } from "../mock/mockData";

const useInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const hasFetched = useRef(false);

  const cb = useCallback(async () => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    try {
      setLoading(true);

      const { data } = await api.get("/api/billing/invoices");

      if (data?.invoices?.length) {
        setInvoices(data.invoices);
      }
    } catch (error) {
      console.error("Failed to fetch billing data:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    cb();
  }, [cb]);

  return { invoices: loading ? MOCK_INVOICES : invoices, loading };
};

export default useInvoices;
